import React from 'react';
import { Sparkles } from 'lucide-react';

/**
 * BetaBadge — pill label signalling a section is still being built out.
 *
 * Why: pages like /market-reports (empty), /blog (3 articles all dated
 * the same day) damage credibility when users expect mature content.
 * A small, clearly visible "BETA" / "En construction" pill resets
 * expectations (used by Zillow, PropertyGuru, Rightmove at rollouts).
 *
 * @param {string} label - displayed text (default "BETA")
 * @param {'amber'|'indigo'|'emerald'|'sky'} variant - color theme
 * @param {string} title - tooltip on hover
 * @param {string} testId - data-testid override
 */
const VARIANTS = {
  amber: 'from-amber-400 to-orange-500 text-white ring-amber-300/60',
  indigo: 'from-indigo-500 to-violet-500 text-white ring-indigo-300/60',
  emerald: 'from-emerald-500 to-teal-500 text-white ring-emerald-300/60',
  sky: 'from-sky-500 to-blue-500 text-white ring-sky-300/60',
};

const BetaBadge = ({
  label = 'BETA',
  variant = 'amber',
  title = 'Section en cours de constitution — du contenu sera ajouté prochainement.',
  testId = 'beta-badge',
}) => (
  <span
    title={title}
    data-testid={testId}
    className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r ${VARIANTS[variant]} px-2.5 py-0.5 text-label font-bold uppercase tracking-[0.15em] shadow ring-1 align-middle`}
  >
    <Sparkles className="h-3 w-3" /> {label}
  </span>
);

export default BetaBadge;
